export const PROPERTY_GALLERY_TEMPLATES = [
    {
        id: "luxury-dark",
        name: "Luxury Dark",
        desc: "Dark marble mood, gold accents, refined drama",
        preview: "bg-slate-900",
        accent: "bg-amber-400",
        bg: "bg-slate-950",
        shell: "from-slate-950 via-slate-900 to-stone-900",
        textPrimary: "text-white",
        textSecondary: "text-white/72",
        textMuted: "text-white/50",
        cardBg: "bg-white/6",
        cardAltBg: "bg-white/8",
        cardBorder: "border-white/10",
        sectionBorder: "border-white/10",
        heroOverlay: "from-slate-950/95 via-slate-950/38 to-black/20",
        badgeClass: "bg-white/10 text-white border border-white/10",
        subtlePanel: "bg-white/6 backdrop-blur-xl",
        galleryTile: "bg-slate-900/70",
        footerBg: "bg-black/20",
        isDark: true,
        accentColor: "#d6b27f",
        headingFont: "\"Iowan Old Style\", \"Palatino Linotype\", \"Book Antiqua\", Georgia, serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "luxury-dark-obsidian",
        name: "Luxury Dark Obsidian",
        desc: "Blacker glass finish with platinum-gold restraint",
        preview: "bg-black",
        accent: "bg-stone-300",
        bg: "bg-black",
        shell: "from-black via-zinc-950 to-stone-950",
        textPrimary: "text-white",
        textSecondary: "text-white/72",
        textMuted: "text-white/48",
        cardBg: "bg-white/5",
        cardAltBg: "bg-white/7",
        cardBorder: "border-white/10",
        sectionBorder: "border-white/10",
        heroOverlay: "from-black/98 via-black/46 to-transparent",
        badgeClass: "bg-white/10 text-white border border-white/10",
        subtlePanel: "bg-black/34 backdrop-blur-xl",
        galleryTile: "bg-zinc-950",
        footerBg: "bg-black/24",
        isDark: true,
        accentColor: "#d4d4d8",
        headingFont: "\"Didot\", \"Bodoni 72\", Georgia, serif",
        bodyFont: "\"Helvetica Neue\", \"Segoe UI\", sans-serif"
    },
    {
        id: "luxury-dark-champagne",
        name: "Luxury Dark Champagne",
        desc: "Soft champagne metallics with hotel-suite polish",
        preview: "bg-neutral-900",
        accent: "bg-amber-200",
        bg: "bg-neutral-950",
        shell: "from-neutral-950 via-stone-900 to-neutral-950",
        textPrimary: "text-white",
        textSecondary: "text-white/74",
        textMuted: "text-white/48",
        cardBg: "bg-white/6",
        cardAltBg: "bg-amber-100/10",
        cardBorder: "border-white/10",
        sectionBorder: "border-white/10",
        heroOverlay: "from-neutral-950/96 via-stone-950/42 to-transparent",
        badgeClass: "bg-white/10 text-white border border-white/10",
        subtlePanel: "bg-black/26 backdrop-blur-xl",
        galleryTile: "bg-neutral-900",
        footerBg: "bg-black/20",
        isDark: true,
        accentColor: "#f3d19c",
        headingFont: "\"Cormorant Garamond\", Georgia, serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "luxury-dark-emerald",
        name: "Luxury Dark Emerald",
        desc: "Private-club green with dark walnut richness",
        preview: "bg-emerald-950",
        accent: "bg-emerald-400",
        bg: "bg-slate-950",
        shell: "from-slate-950 via-emerald-950 to-black",
        textPrimary: "text-white",
        textSecondary: "text-emerald-50/74",
        textMuted: "text-emerald-50/44",
        cardBg: "bg-white/5",
        cardAltBg: "bg-emerald-400/10",
        cardBorder: "border-white/10",
        sectionBorder: "border-white/10",
        heroOverlay: "from-slate-950/96 via-emerald-950/40 to-transparent",
        badgeClass: "bg-white/10 text-white border border-white/10",
        subtlePanel: "bg-black/24 backdrop-blur-xl",
        galleryTile: "bg-slate-900",
        footerBg: "bg-black/20",
        isDark: true,
        accentColor: "#34d399",
        headingFont: "\"Iowan Old Style\", Georgia, serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "luxury-dark-ruby",
        name: "Luxury Dark Ruby",
        desc: "Deep garnet accents with bold fashion-house energy",
        preview: "bg-zinc-950",
        accent: "bg-rose-500",
        bg: "bg-zinc-950",
        shell: "from-black via-zinc-950 to-rose-950",
        textPrimary: "text-white",
        textSecondary: "text-white/72",
        textMuted: "text-white/46",
        cardBg: "bg-white/5",
        cardAltBg: "bg-rose-500/10",
        cardBorder: "border-white/10",
        sectionBorder: "border-white/10",
        heroOverlay: "from-black/97 via-zinc-950/42 to-transparent",
        badgeClass: "bg-white/10 text-white border border-white/10",
        subtlePanel: "bg-black/28 backdrop-blur-xl",
        galleryTile: "bg-zinc-900",
        footerBg: "bg-black/22",
        isDark: true,
        accentColor: "#e11d48",
        headingFont: "\"Didot\", Georgia, serif",
        bodyFont: "\"Helvetica Neue\", \"Segoe UI\", sans-serif"
    },
    {
        id: "luxury-dark-sapphire",
        name: "Luxury Dark Sapphire",
        desc: "Midnight navy with polished penthouse cool",
        preview: "bg-slate-950",
        accent: "bg-sky-400",
        bg: "bg-slate-950",
        shell: "from-slate-950 via-blue-950 to-black",
        textPrimary: "text-white",
        textSecondary: "text-sky-50/74",
        textMuted: "text-sky-50/44",
        cardBg: "bg-white/5",
        cardAltBg: "bg-sky-400/10",
        cardBorder: "border-white/10",
        sectionBorder: "border-white/10",
        heroOverlay: "from-slate-950/97 via-blue-950/40 to-transparent",
        badgeClass: "bg-white/10 text-white border border-white/10",
        subtlePanel: "bg-black/28 backdrop-blur-xl",
        galleryTile: "bg-slate-900",
        footerBg: "bg-black/20",
        isDark: true,
        accentColor: "#38bdf8",
        headingFont: "\"Bodoni 72\", Georgia, serif",
        bodyFont: "\"Helvetica Neue\", \"Segoe UI\", sans-serif"
    },
    {
        id: "modern-light",
        name: "Modern Light",
        desc: "Bright editorial minimalism with crisp structure",
        preview: "bg-white",
        accent: "bg-slate-800",
        bg: "bg-stone-50",
        shell: "from-white via-stone-50 to-slate-100",
        textPrimary: "text-slate-900",
        textSecondary: "text-slate-600",
        textMuted: "text-slate-400",
        cardBg: "bg-white/90",
        cardAltBg: "bg-slate-50/90",
        cardBorder: "border-slate-200/80",
        sectionBorder: "border-slate-200",
        heroOverlay: "from-white/92 via-white/38 to-transparent",
        badgeClass: "bg-white/85 text-slate-700 border border-slate-200/80",
        subtlePanel: "bg-white/80 backdrop-blur-xl",
        galleryTile: "bg-white",
        footerBg: "bg-white/70",
        isDark: false,
        accentColor: "#1e293b",
        headingFont: "\"Canela\", \"Cormorant Garamond\", Georgia, serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "coastal-breeze",
        name: "Coastal Breeze",
        desc: "Ocean-washed blues with airy luxury",
        preview: "bg-sky-50",
        accent: "bg-sky-500",
        bg: "bg-sky-50",
        shell: "from-cyan-50 via-sky-50 to-blue-100",
        textPrimary: "text-slate-900",
        textSecondary: "text-slate-600",
        textMuted: "text-slate-400",
        cardBg: "bg-white/88",
        cardAltBg: "bg-sky-100/60",
        cardBorder: "border-sky-200/80",
        sectionBorder: "border-sky-200",
        heroOverlay: "from-sky-950/70 via-sky-900/20 to-transparent",
        badgeClass: "bg-white/80 text-sky-900 border border-sky-100",
        subtlePanel: "bg-white/76 backdrop-blur-xl",
        galleryTile: "bg-white",
        footerBg: "bg-white/70",
        isDark: false,
        accentColor: "#0ea5e9",
        headingFont: "\"Fraunces\", Georgia, serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "classic-elegant",
        name: "Classic Elegant",
        desc: "Warm traditional styling with heritage tones",
        preview: "bg-amber-50",
        accent: "bg-amber-700",
        bg: "bg-amber-50",
        shell: "from-amber-50 via-orange-50 to-stone-100",
        textPrimary: "text-slate-900",
        textSecondary: "text-slate-600",
        textMuted: "text-slate-400",
        cardBg: "bg-white/88",
        cardAltBg: "bg-amber-100/60",
        cardBorder: "border-amber-200/80",
        sectionBorder: "border-amber-200",
        heroOverlay: "from-stone-950/68 via-stone-900/18 to-transparent",
        badgeClass: "bg-white/82 text-amber-900 border border-amber-100",
        subtlePanel: "bg-white/82 backdrop-blur-xl",
        galleryTile: "bg-white",
        footerBg: "bg-white/70",
        isDark: false,
        accentColor: "#92400e",
        headingFont: "\"Cormorant Garamond\", Georgia, serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "bold-editorial",
        name: "Bold Editorial",
        desc: "High-fashion contrast with statement red",
        preview: "bg-slate-800",
        accent: "bg-rose-500",
        bg: "bg-zinc-950",
        shell: "from-zinc-950 via-slate-950 to-black",
        textPrimary: "text-white",
        textSecondary: "text-white/72",
        textMuted: "text-white/48",
        cardBg: "bg-white/6",
        cardAltBg: "bg-white/8",
        cardBorder: "border-white/10",
        sectionBorder: "border-white/10",
        heroOverlay: "from-black/96 via-zinc-950/44 to-transparent",
        badgeClass: "bg-white/10 text-white border border-white/10",
        subtlePanel: "bg-black/30 backdrop-blur-xl",
        galleryTile: "bg-zinc-900",
        footerBg: "bg-black/20",
        isDark: true,
        accentColor: "#dc2626",
        headingFont: "\"Didot\", \"Bodoni 72\", Georgia, serif",
        bodyFont: "\"Helvetica Neue\", \"Segoe UI\", sans-serif"
    },
    {
        id: "nature-inspired",
        name: "Nature Inspired",
        desc: "Organic greens with soft biophilic warmth",
        preview: "bg-emerald-50",
        accent: "bg-emerald-600",
        bg: "bg-emerald-50",
        shell: "from-emerald-50 via-lime-50 to-stone-100",
        textPrimary: "text-slate-900",
        textSecondary: "text-slate-600",
        textMuted: "text-slate-400",
        cardBg: "bg-white/88",
        cardAltBg: "bg-emerald-100/60",
        cardBorder: "border-emerald-200/80",
        sectionBorder: "border-emerald-200",
        heroOverlay: "from-emerald-950/76 via-emerald-900/18 to-transparent",
        badgeClass: "bg-white/85 text-emerald-900 border border-emerald-100",
        subtlePanel: "bg-white/80 backdrop-blur-xl",
        galleryTile: "bg-white",
        footerBg: "bg-white/70",
        isDark: false,
        accentColor: "#16a34a",
        headingFont: "\"Fraunces\", Georgia, serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "minimalist-scandinavian",
        name: "Minimalist Scandinavian",
        desc: "Warm neutrals, restrained luxury, calm whitespace",
        preview: "bg-stone-100",
        accent: "bg-stone-500",
        bg: "bg-stone-100",
        shell: "from-stone-50 via-stone-100 to-neutral-200",
        textPrimary: "text-stone-900",
        textSecondary: "text-stone-600",
        textMuted: "text-stone-400",
        cardBg: "bg-white/84",
        cardAltBg: "bg-stone-200/55",
        cardBorder: "border-stone-200/90",
        sectionBorder: "border-stone-200",
        heroOverlay: "from-stone-950/64 via-stone-900/16 to-transparent",
        badgeClass: "bg-white/86 text-stone-700 border border-stone-200",
        subtlePanel: "bg-white/78 backdrop-blur-xl",
        galleryTile: "bg-white",
        footerBg: "bg-white/72",
        isDark: false,
        accentColor: "#78716c",
        headingFont: "\"Neue Haas Grotesk Display\", \"Helvetica Neue\", sans-serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "urban-loft",
        name: "Urban Loft",
        desc: "Industrial polish, concrete neutrals, bold typography",
        preview: "bg-zinc-200",
        accent: "bg-orange-500",
        bg: "bg-zinc-200",
        shell: "from-zinc-100 via-stone-200 to-zinc-300",
        textPrimary: "text-zinc-950",
        textSecondary: "text-zinc-700",
        textMuted: "text-zinc-500",
        cardBg: "bg-white/76",
        cardAltBg: "bg-zinc-100/70",
        cardBorder: "border-zinc-300/80",
        sectionBorder: "border-zinc-300",
        heroOverlay: "from-zinc-950/84 via-zinc-900/24 to-transparent",
        badgeClass: "bg-white/82 text-zinc-800 border border-zinc-300/80",
        subtlePanel: "bg-white/68 backdrop-blur-xl",
        galleryTile: "bg-white/90",
        footerBg: "bg-white/65",
        isDark: false,
        accentColor: "#ea580c",
        headingFont: "\"Bebas Neue\", \"Arial Narrow\", sans-serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "mediterranean-villa",
        name: "Mediterranean Villa",
        desc: "Terracotta glow, olive accents, sun-washed romance",
        preview: "bg-orange-50",
        accent: "bg-orange-600",
        bg: "bg-orange-50",
        shell: "from-orange-50 via-amber-50 to-lime-50",
        textPrimary: "text-stone-900",
        textSecondary: "text-stone-700",
        textMuted: "text-stone-500",
        cardBg: "bg-white/84",
        cardAltBg: "bg-orange-100/55",
        cardBorder: "border-orange-200/90",
        sectionBorder: "border-orange-200",
        heroOverlay: "from-stone-950/74 via-orange-950/22 to-transparent",
        badgeClass: "bg-white/84 text-orange-900 border border-orange-100",
        subtlePanel: "bg-white/78 backdrop-blur-xl",
        galleryTile: "bg-white",
        footerBg: "bg-white/74",
        isDark: false,
        accentColor: "#c2410c",
        headingFont: "\"Cormorant Garamond\", Georgia, serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "penthouse-noir",
        name: "Penthouse Noir",
        desc: "Ultra-dark cinematic luxury with platinum highlights",
        preview: "bg-black",
        accent: "bg-slate-300",
        bg: "bg-black",
        shell: "from-black via-zinc-950 to-slate-950",
        textPrimary: "text-white",
        textSecondary: "text-white/72",
        textMuted: "text-white/45",
        cardBg: "bg-white/5",
        cardAltBg: "bg-white/7",
        cardBorder: "border-white/10",
        sectionBorder: "border-white/10",
        heroOverlay: "from-black/96 via-black/48 to-transparent",
        badgeClass: "bg-white/10 text-white border border-white/10",
        subtlePanel: "bg-black/34 backdrop-blur-xl",
        galleryTile: "bg-zinc-950",
        footerBg: "bg-black/20",
        isDark: true,
        accentColor: "#cbd5e1",
        headingFont: "\"Didot\", \"Bodoni 72\", Georgia, serif",
        bodyFont: "\"Helvetica Neue\", \"Segoe UI\", sans-serif"
    },
    {
        id: "art-deco-glamour",
        name: "Art Deco Glamour",
        desc: "Champagne metallics, geometric drama, old-world glamour",
        preview: "bg-neutral-950",
        accent: "bg-amber-300",
        bg: "bg-neutral-950",
        shell: "from-black via-neutral-950 to-amber-950",
        textPrimary: "text-white",
        textSecondary: "text-white/72",
        textMuted: "text-white/45",
        cardBg: "bg-white/6",
        cardAltBg: "bg-amber-300/10",
        cardBorder: "border-white/10",
        sectionBorder: "border-white/10",
        heroOverlay: "from-black/96 via-black/44 to-transparent",
        badgeClass: "bg-white/10 text-white border border-white/10",
        subtlePanel: "bg-black/30 backdrop-blur-xl",
        galleryTile: "bg-neutral-900",
        footerBg: "bg-black/20",
        isDark: true,
        accentColor: "#f5d08a",
        headingFont: "\"Bodoni 72\", \"Didot\", Georgia, serif",
        bodyFont: "\"Helvetica Neue\", \"Segoe UI\", sans-serif"
    },
    {
        id: "mountain-retreat",
        name: "Mountain Retreat",
        desc: "Forest depth, walnut warmth, lodge-level sophistication",
        preview: "bg-stone-800",
        accent: "bg-lime-500",
        bg: "bg-stone-900",
        shell: "from-stone-950 via-emerald-950 to-stone-900",
        textPrimary: "text-white",
        textSecondary: "text-stone-200/78",
        textMuted: "text-stone-200/45",
        cardBg: "bg-white/6",
        cardAltBg: "bg-lime-400/10",
        cardBorder: "border-white/10",
        sectionBorder: "border-white/10",
        heroOverlay: "from-stone-950/96 via-stone-900/40 to-transparent",
        badgeClass: "bg-white/10 text-white border border-white/10",
        subtlePanel: "bg-black/24 backdrop-blur-xl",
        galleryTile: "bg-stone-900",
        footerBg: "bg-black/20",
        isDark: true,
        accentColor: "#84cc16",
        headingFont: "\"Fraunces\", Georgia, serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "tropical-paradise",
        name: "Tropical Paradise",
        desc: "Ocean blues, sunset warmth, polished resort energy",
        preview: "bg-cyan-100",
        accent: "bg-teal-500",
        bg: "bg-cyan-50",
        shell: "from-cyan-50 via-sky-100 to-amber-50",
        textPrimary: "text-slate-900",
        textSecondary: "text-slate-700",
        textMuted: "text-slate-500",
        cardBg: "bg-white/86",
        cardAltBg: "bg-cyan-100/70",
        cardBorder: "border-cyan-100",
        sectionBorder: "border-cyan-100",
        heroOverlay: "from-sky-950/76 via-sky-900/18 to-transparent",
        badgeClass: "bg-white/84 text-cyan-900 border border-cyan-100",
        subtlePanel: "bg-white/80 backdrop-blur-xl",
        galleryTile: "bg-white",
        footerBg: "bg-white/74",
        isDark: false,
        accentColor: "#0d9488",
        headingFont: "\"Fraunces\", Georgia, serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "modern-farmhouse",
        name: "Modern Farmhouse",
        desc: "Cream, sage, charcoal, and clean rustic balance",
        preview: "bg-stone-100",
        accent: "bg-emerald-600",
        bg: "bg-stone-100",
        shell: "from-stone-50 via-stone-100 to-emerald-50",
        textPrimary: "text-stone-900",
        textSecondary: "text-stone-700",
        textMuted: "text-stone-500",
        cardBg: "bg-white/88",
        cardAltBg: "bg-emerald-100/60",
        cardBorder: "border-stone-200",
        sectionBorder: "border-stone-200",
        heroOverlay: "from-stone-950/72 via-stone-900/16 to-transparent",
        badgeClass: "bg-white/86 text-stone-800 border border-stone-200",
        subtlePanel: "bg-white/80 backdrop-blur-xl",
        galleryTile: "bg-white",
        footerBg: "bg-white/74",
        isDark: false,
        accentColor: "#3f6212",
        headingFont: "\"Cormorant Garamond\", Georgia, serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "scandinavian-warmth",
        name: "Scandinavian Warmth",
        desc: "Pale oak calm, quiet luxury, softened minimalism",
        preview: "bg-zinc-100",
        accent: "bg-amber-500",
        bg: "bg-zinc-50",
        shell: "from-white via-zinc-50 to-stone-100",
        textPrimary: "text-zinc-900",
        textSecondary: "text-zinc-700",
        textMuted: "text-zinc-500",
        cardBg: "bg-white/86",
        cardAltBg: "bg-stone-100/70",
        cardBorder: "border-zinc-200",
        sectionBorder: "border-zinc-200",
        heroOverlay: "from-stone-950/66 via-stone-900/14 to-transparent",
        badgeClass: "bg-white/88 text-zinc-700 border border-zinc-200",
        subtlePanel: "bg-white/82 backdrop-blur-xl",
        galleryTile: "bg-white",
        footerBg: "bg-white/76",
        isDark: false,
        accentColor: "#d97706",
        headingFont: "\"Neue Haas Grotesk Display\", \"Helvetica Neue\", sans-serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "desert-modern",
        name: "Desert Modern",
        desc: "Clay, sand, shadow, and architectural restraint",
        preview: "bg-orange-100",
        accent: "bg-orange-700",
        bg: "bg-orange-50",
        shell: "from-orange-50 via-amber-50 to-stone-200",
        textPrimary: "text-stone-900",
        textSecondary: "text-stone-700",
        textMuted: "text-stone-500",
        cardBg: "bg-white/86",
        cardAltBg: "bg-orange-100/70",
        cardBorder: "border-orange-100",
        sectionBorder: "border-orange-100",
        heroOverlay: "from-stone-950/80 via-orange-950/18 to-transparent",
        badgeClass: "bg-white/84 text-orange-900 border border-orange-100",
        subtlePanel: "bg-white/78 backdrop-blur-xl",
        galleryTile: "bg-white",
        footerBg: "bg-white/72",
        isDark: false,
        accentColor: "#c2410c",
        headingFont: "\"Bodoni 72\", Georgia, serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "parisian-classic",
        name: "Parisian Classic",
        desc: "Ivory, black, antique gold, and timeless elegance",
        preview: "bg-stone-50",
        accent: "bg-amber-600",
        bg: "bg-stone-50",
        shell: "from-stone-50 via-neutral-50 to-amber-50",
        textPrimary: "text-neutral-950",
        textSecondary: "text-neutral-700",
        textMuted: "text-neutral-500",
        cardBg: "bg-white/88",
        cardAltBg: "bg-amber-100/55",
        cardBorder: "border-stone-200",
        sectionBorder: "border-stone-200",
        heroOverlay: "from-black/72 via-black/14 to-transparent",
        badgeClass: "bg-white/88 text-neutral-800 border border-stone-200",
        subtlePanel: "bg-white/82 backdrop-blur-xl",
        galleryTile: "bg-white",
        footerBg: "bg-white/76",
        isDark: false,
        accentColor: "#b45309",
        headingFont: "\"Didot\", \"Bodoni 72\", Georgia, serif",
        bodyFont: "\"Helvetica Neue\", \"Segoe UI\", sans-serif"
    },
    {
        id: "coastal-luxury",
        name: "Coastal Luxury",
        desc: "Navy polish, shell white, and five-star hospitality calm",
        preview: "bg-sky-100",
        accent: "bg-sky-700",
        bg: "bg-sky-50",
        shell: "from-white via-sky-50 to-cyan-100",
        textPrimary: "text-slate-900",
        textSecondary: "text-slate-700",
        textMuted: "text-slate-500",
        cardBg: "bg-white/88",
        cardAltBg: "bg-sky-100/70",
        cardBorder: "border-sky-100",
        sectionBorder: "border-sky-100",
        heroOverlay: "from-slate-950/76 via-sky-950/16 to-transparent",
        badgeClass: "bg-white/86 text-sky-900 border border-sky-100",
        subtlePanel: "bg-white/82 backdrop-blur-xl",
        galleryTile: "bg-white",
        footerBg: "bg-white/76",
        isDark: false,
        accentColor: "#0369a1",
        headingFont: "\"Cormorant Garamond\", Georgia, serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    },
    {
        id: "gallery-white-editorial",
        name: "Gallery White Editorial",
        desc: "Art-book minimalism with generous white space",
        preview: "bg-white",
        accent: "bg-black",
        bg: "bg-white",
        shell: "from-white via-slate-50 to-white",
        textPrimary: "text-slate-950",
        textSecondary: "text-slate-700",
        textMuted: "text-slate-400",
        cardBg: "bg-white/94",
        cardAltBg: "bg-slate-50/90",
        cardBorder: "border-slate-200",
        sectionBorder: "border-slate-200",
        heroOverlay: "from-white/94 via-white/30 to-transparent",
        badgeClass: "bg-white/92 text-slate-900 border border-slate-200",
        subtlePanel: "bg-white/90 backdrop-blur-xl",
        galleryTile: "bg-white",
        footerBg: "bg-white/80",
        isDark: false,
        accentColor: "#020617",
        headingFont: "\"Helvetica Neue\", \"Segoe UI\", sans-serif",
        bodyFont: "\"Avenir Next\", \"Segoe UI\", sans-serif"
    }
];

export const PROPERTY_GALLERY_TEMPLATE_MAP = PROPERTY_GALLERY_TEMPLATES.reduce((accumulator, template) => {
    accumulator[template.id] = template;
    return accumulator;
}, {});

export const DEFAULT_PROPERTY_GALLERY_TEMPLATE = "luxury-dark";

export const getPropertyGalleryTemplate = (templateId) => {
    return PROPERTY_GALLERY_TEMPLATE_MAP[templateId] || PROPERTY_GALLERY_TEMPLATE_MAP[DEFAULT_PROPERTY_GALLERY_TEMPLATE];
};
